// extracted by mini-css-extract-plugin
export var tips = "tips-module--tips--gPUjH";
export var center = "tips-module--center--cpZzv";
export var tip = "tips-module--tip--9-5ep";